import { FormHelperText, Grid, InputLabel, Tooltip } from '@material-ui/core';
import { TextBox as InputText } from '../../../../Core/FormInput';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import DeleteIcon from '@material-ui/icons/Delete';
import SignaturePad from 'react-signature-canvas';
import { useContext, useEffect, useRef, useState } from 'react';
import { InspectionCheCkContaxt } from './InspectionCheckProvide';

export const InSpectionSignOff = ({ classes }) => {
    const { state, useDefaultSig, clear, GetTechnicianSign, signCanvas, portalSettings, flags, handleInput } = useContext(InspectionCheCkContaxt);
    const isReadOnly = Boolean(state.isDisabled || state.vehicleInspectionInspectorSignature);

    const containerRef = useRef(null);
    const [canvasWidth, setCanvasWidth] = useState(0);

    useEffect(() => {
        const updateWidth = () => {
            if (containerRef.current) {
                const w = containerRef.current.clientWidth || containerRef.current.offsetWidth;
                if (w > 0) {
                    setCanvasWidth(w);
                }
            }
        };

        updateWidth();
        const timer = setTimeout(updateWidth, 150);
        window.addEventListener('resize', updateWidth);

        return () => {
            clearTimeout(timer);
            window.removeEventListener('resize', updateWidth);
        };
    }, [state.imgtechniciansign]);

    let TechnicianDeclaration = portalSettings.portalSettingTechnicianDeclaration?.replace('{eventname}', flags.scheduleEventName) || '';

    return (
        <Grid item xs={12} md={12}>
            <div className={classes.sectionCard} style={{ marginBottom: 14 }}>
                <div className={classes.sectionHeader}>
                    <div className={classes.sectionTitleWrap}>
                        <span className={classes.sectionAccent} />
                        <h3 className={classes.sectionTitleText}>Vehicle Inspector </h3>
                    </div>
                </div>

                <div style={{ padding: '14px 18px' }}>
                    {TechnicianDeclaration && (
                        <div
                            style={{
                                color: '#64748b',
                                fontSize: 12,
                                marginBottom: 14,
                                lineHeight: 1.5
                            }}
                            dangerouslySetInnerHTML={{ __html: TechnicianDeclaration }}
                        />
                    )}

                    <Grid container spacing={2} justify="space-between">
                        <Grid item xs={12} lg={6}>
                            <InputLabel shrink className={classes.fieldLabel} style={{ marginBottom: 4 }}>
                                Vehicle Checker Comment
                            </InputLabel>
                            <InputText
                                multiline
                                margin="none"
                                disabled={isReadOnly}
                                placeholder="Vehicle checker comment"
                                name="vehicleInspectionInspectionComment"
                                onChange={handleInput}
                                value={state.vehicleInspectionInspectionComment}
                                fullWidth
                                InputProps={{
                                    style: {
                                        height: 125,
                                        alignItems: 'flex-start',
                                        backgroundColor: '#fff'
                                        // fontSize: 12
                                    }
                                }}
                                inputProps={{
                                    style: {
                                        height: '100%',
                                        boxSizing: 'border-box'
                                        // fontSize: 12
                                    }
                                }}
                                style={{
                                    height: 125,
                                    margin: 0
                                }}
                            />
                            <FormHelperText error>{state.errors?.vehicleInspectionInspectionComment}</FormHelperText>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                            <div style={{ position: 'relative' }}>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginBottom: state.imgtechniciansign ? 2 : -3
                                    }}
                                >
                                    <InputLabel shrink className={classes.fieldLabel} style={{ margin: 0 }}>
                                        Signature{' '}
                                        {!isReadOnly && state.signAvailable ? (
                                            <Tooltip title="Use default signature">
                                                <BorderColorIcon
                                                    onClick={useDefaultSig}
                                                    style={{ cursor: 'pointer', verticalAlign: 'middle', marginLeft: 6, fontSize: 16 }}
                                                />
                                            </Tooltip>
                                        ) : null}
                                    </InputLabel>
                                    {!isReadOnly && (
                                        <Tooltip title="Clear Signature">
                                            <DeleteIcon
                                                onClick={clear}
                                                style={{
                                                    cursor: 'pointer',
                                                    color: '#f50057',
                                                    fontSize: 18
                                                }}
                                            />
                                        </Tooltip>
                                    )}
                                </div>

                                {state.imgtechniciansign ? (
                                    <div
                                        style={{
                                            border: '1px solid #ced4da',
                                            borderRadius: 4,
                                            background: '#fafafa',
                                            padding: 4,
                                            height: 125,
                                            boxSizing: 'border-box',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <img
                                            src={state.techniciansign}
                                            alt="my signature"
                                            style={{
                                                display: 'block',
                                                maxHeight: 115,
                                                maxWidth: '100%',
                                                objectFit: 'contain'
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <div
                                        ref={containerRef}
                                        style={{
                                            border: '1px solid #ced4da',
                                            borderRadius: 4,
                                            background: '#ffffff',
                                            height: 125,
                                            boxSizing: 'border-box',
                                            overflow: 'hidden',
                                            width: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        {canvasWidth > 0 ? (
                                            <SignaturePad
                                                ref={signCanvas}
                                                canvasProps={{
                                                    width: canvasWidth,
                                                    height: 123,
                                                    style: {
                                                        width: `${canvasWidth}px`,
                                                        height: '123px',
                                                        display: 'block',
                                                        cursor: 'crosshair',
                                                        backgroundColor: '#ffffff'
                                                    }
                                                }}
                                                onEnd={() => {
                                                    GetTechnicianSign();
                                                }}
                                            />
                                        ) : (
                                            <SignaturePad
                                                ref={signCanvas}
                                                canvasProps={{
                                                    height: 123,
                                                    style: {
                                                        width: '100%',
                                                        height: '123px',
                                                        display: 'block',
                                                        cursor: 'crosshair',
                                                        backgroundColor: '#ffffff'
                                                    }
                                                }}
                                                onEnd={() => {
                                                    GetTechnicianSign();
                                                }}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                            <FormHelperText error>{state.errors?.techniciansign}</FormHelperText>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </Grid>
    );
};

export default InSpectionSignOff;
